module.exports = "/static/media/facebook.41fcce62.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/facebook.svg
// module id = 1491
// module chunks = 0